var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 45.536,
    fill: "#007cc2",
    viewBox: "0 0 40 45.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1500.719,60.537l-2.04,1.181V82.945l18.375-10.609V51.108Z",
    transform: "translate(-1477.053 -37.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.83,45.35l-7.067-4.091-18.885,10.9,7.076,4.091Z",
    transform: "translate(-1482.839 -41.259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.621,50.4l-8.144-4.639-18.876,10.9,1.077.557,7.067,4.081,7.029-4.053Z",
    transform: "translate(-1479.82 -39.499)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.485,62.347l-3.382-1.738V55.2l-6.972-4.015V72.267L1501.374,82.8V61.723l-7.889-4.544Z",
    transform: "translate(-1483.131 -37.378)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/boxIcon.363b1c4daf04458e0dd016185df0a82b.svg";
export { ForwardRef as ReactComponent };